export default {
  dashboard: 'Dashboard',
  csWorkbench: 'CS Workbench',
  routeWorkbench: 'Route Workbench',
  productOrderRecords: 'Product Order Records',
  businessOrders: 'Business Orders',
  businessOrderManage: 'Business Order Management',
  businessOrderDetail: 'Business Order Detail',
  agreement: 'Agreements',
  agreementOrders: 'Agreement Orders',
  customers: 'Customers',
  accountLock: 'Account Lock Management',
  basicData: 'Basic Data',
  system: {
    title: 'System',
    users: 'Users',
    dictionary: 'Dictionary',
    role: 'Roles',
    permission: 'Permissions',
    organization: 'Organizations',
    config: 'System Config',
    currency: 'Currencies & Exchange Rates',
    palletType: 'Pallet Types',
    mawbPool: 'MAWB Pool',
    loginLog: 'Login Logs',
  },
}
